import Vue from 'vue'
import VueRouter from 'vue-router'
import registration from "@/registration"
import appConfigGlobal from "@/app.config.global"

const appRoutes = registration.map(e => e.route);

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'App',
    redirect: appConfigGlobal.defaultRouteRedirect,
  },
  {
    path: '/settings',
    name: 'User Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/_views/my/Settings.vue'),
  },
  {
    path: '/logins',
    name: 'Logins',
    component: () => import(/* webpackChunkName: "Logins" */ '@/_views/my/Logins.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '@/_views/about'),
  },

  ...appRoutes

];

const router = new VueRouter({
  routes
})

export default router